import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/system";
import {
  Button,
  Autocomplete,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@mui/material/styles";
import "../Styles/product.css";
import { DeleteOutline, PhotoCamera } from "@mui/icons-material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import TextField from "@mui/material/TextField";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import api from "./../Data/api";
import { DELETE, GET, UPDATE, UPLOAD } from "../Functions/apiFunction";
import { tokens } from "../theme";
import image from "../Data/image";

function Product() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const param = useParams();
  const [product, setproduct] = useState();
  const [title, settitle] = useState();
  const [quantity, setquantity] = useState();
  const [price, setprice] = useState();
  const [MRP, setMRP] = useState();
  const [tax, settax] = useState();
  const [stock, setstock] = useState();
  const [category, setcategory] = useState(null);
  const [categories, setcategories] = useState([]);
  const [subCat, setsubCat] = useState(null);
  const [subCategories, setsubCategories] = useState([]);
  const [offer, setoffer] = useState();
  const [desc, setdesc] = useState();
  const [claimer, setclaimer] = useState();
  const [subs, setsubs] = useState(0);
  const [hasbottle, sethasbottle] = useState(0);
  const [loading, setloading] = useState(false);
  const [snakbarOpen, setsnakbarOpen] = useState(false);
  const [alertType, setalertType] = useState("");
  const [alertMsg, setalertMsg] = useState("");
  const [DailogOpen, setDailogOpen] = useState(false);
  const [reFetch, setreFetch] = useState(false);
  const [img, setimg] = useState();
  const [uploadImage, setuploadImage] = useState();

  const [deleting, setdeleting] = useState();
  const [sliderImages, setsliderImages] = useState([]);
  const [uploading, setuploading] = useState(false);
  // Time restriction
  const [orderStartTime, setOrderStartTime] = useState("");
  const [orderEndTime, setOrderEndTime] = useState("");
  const [enableTimeRestriction, setEnableTimeRestriction] = useState(false);
  // Pincode restriction
  const [allPincodes, setAllPincodes] = useState([]);
  const [selectedPincodes, setSelectedPincodes] = useState([]);
  const [enablePincodeRestriction, setEnablePincodeRestriction] = useState(false);

  const handleSnakBarOpen = () => setsnakbarOpen(true);
  const handleSnakBarClose = () => setsnakbarOpen(false);
  const handleClickOpen = () => {
    setDailogOpen(true);
  };

  const handleClose = () => {
    setDailogOpen(false);
  };

  const admin = JSON.parse(sessionStorage.getItem("admin"));
  const token = `Bearer ${admin.token}`;

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
    fetchAllPincodes();
  }, []);

  // Fetch subcategories when category changes
  useEffect(() => {
    if (category) {
      fetchSubCategories(category.id);
    } else {
      setsubCategories([]);
    }
  }, [category]);

  useEffect(() => {
    // Get product
    const getproduct = async () => {
      const url = `${api}/get_product/${param.id}`;
      const products = await GET(token, url);
      const product = products.data;
      setproduct(product);
      settitle(product.title);
      setquantity(product.qty_text);
      setprice(product.price);
      setMRP(product.mrp);
      settax(product.tax);
      setstock(product.stock_qty);
      
      // Set category object
      if (product.cat_id && product.cat_title) {
        setcategory({ id: product.cat_id, title: product.cat_title });
      }
      
      // Set subcategory object
      if (product.sub_cat_id && product.sub_cat_title) {
        setsubCat({ id: product.sub_cat_id, title: product.sub_cat_title });
      }
      
      setoffer(product.offer_text);
      setclaimer(product.disclaimer);
      setdesc(product.description);
      setsubs(product.subscription);
      sethasbottle(product.has_bottle ?? 0);
      // Load time restriction
      if (product.order_start_time) {
        setOrderStartTime(product.order_start_time.substring(0, 5));
        setEnableTimeRestriction(true);
      }
      if (product.order_end_time) {
        setOrderEndTime(product.order_end_time.substring(0, 5));
        setEnableTimeRestriction(true);
      }
      // Load pincode restrictions
      if (product.pincodes && product.pincodes.length > 0) {
        setEnablePincodeRestriction(true);
      }
      setimg(
        product.image != null && {
          url: `${image}/${product.image}`,
          id: product.image_id,
        }
      );
      setsliderImages(product.slider_image);
      // Populate selected pincodes from product data
      if (product.pincodes && product.pincodes.length > 0) {
        // We'll match against allPincodes after they load
        setSelectedPincodes(
          product.pincodes.map((pc) => ({ pin_code: pc }))
        );
      }
    };
    getproduct();
  }, [reFetch, token, param.id]);

  const fetchAllPincodes = async () => {
    try {
      const url = `${api}/get_pincode`;
      const response = await GET(token, url);
      if (response?.data) setAllPincodes(response.data);
    } catch (error) {
      console.error("Error fetching pincodes:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const url = `${api}/get_cat`;
      const response = await GET(token, url);
      if (response.response === 200) {
        setcategories(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubCategories = async (catId) => {
    try {
      const url = `${api}/get_sub_cat/cat_id/${catId}`;
      const response = await GET(token, url);
      if (response.response === 200) {
        setsubCategories(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      setsubCategories([]);
    }
  };

  // Delete Product
  const DeleteProduct = async () => {
    const url = `${api}/delete_product`;
    const data = {
      id: param.id,
    };
    setloading(true);
    const dltProdct = await DELETE(token, url, data);
    setloading(false);
    if (dltProdct.response === 200) {
      handleSnakBarOpen();
      setalertType("success");
      setalertMsg("Successfully Deleted");
      handleClose();
      setTimeout(() => {
        navigate("/Products");
      }, 1200);
    } else {
      handleSnakBarOpen();
      setalertType("error");
      setalertMsg("Something went Wrong! Please Try Again");
      handleClose();
    }
  };

  // Update Product

  const updateProduct = async (e) => {
    e.preventDefault();
    const data = {
      id: param.id,
      title: title,
      qty_text: quantity,
      sub_cat_id: subCat?.id,
      price: price,
      mrp: MRP,
      tax: tax,
      stock_qty: stock,
      offer_text: offer,
      description: desc,
      disclaimer: claimer,
      subscription: subs,
      has_bottle: hasbottle,
      order_start_time: enableTimeRestriction && orderStartTime ? orderStartTime : null,
      order_end_time: enableTimeRestriction && orderEndTime ? orderEndTime : null,
    };

    const url = `${api}/update_product`;
    setloading(true);
    const update = await UPDATE(token, url, data);
    if (uploadImage) {
      let UploadUrl = `${api}/product/upload_image`;
      const uploadData = { image: uploadImage, image_type: 1, id: param.id };
      await UPLOAD(token, UploadUrl, uploadData);
    }
    // Save pincode restrictions
    await UPDATE(token, `${api}/product_pincode/bulk_update`, {
      product_id: param.id,
      pincodes: enablePincodeRestriction ? selectedPincodes.map((p) => p.pin_code) : [],
    });
    setloading(false);
    if (update.response === 200) {
      handleSnakBarOpen();
      setalertType("success");
      setalertMsg("Product Details Updated");
      handleClose();
      setTimeout(() => { setreFetch(!reFetch); }, 800);
    } else if (update.response === 201) {
      handleSnakBarOpen();
      setalertType("error");
      setalertMsg(update.message);
    } else {
      handleSnakBarOpen();
      setalertType("error");
      setalertMsg("Something went Wrong! Please Try Again");
      handleClose();
    }
  };

  // delete Image

  const deleteFile = async (id) => {
    const url = `${api}/product/delete_image`;
    const data = {
      id: id,
    };
    console.log(data);
    setdeleting(true);
    const deleteImg = await UPDATE(token, url, data);
    console.log(deleteImg);
    setdeleting(false);
    if (deleteImg.response === 200) {
      setreFetch(!reFetch);
      handleSnakBarOpen();
      setalertType("success");
      handleClose();
      setalertMsg(deleteImg.message);
    } else if (deleteImg.response === 201) {
      handleSnakBarOpen();
      setalertType("error");
      setalertMsg(deleteImg.message);
    } else {
      handleSnakBarOpen();
      setalertType("error");
      setalertMsg("Something went Wrong! Please Try Again");
    }
  };

  return (
    <>
      <Snackbar
        open={snakbarOpen}
        autoHideDuration={3000}
        onClose={handleSnakBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnakBarClose}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMsg}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "10px",
          borderBottom:
            theme.palette.mode === "dark"
              ? "0.5px solid #E1E3E6"
              : "1px solid #757D8A",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconButton
            aria-label="delete"
            onClick={() => {
              navigate("/Products");
            }}
          >
            <ArrowBackIcon />
          </IconButton>{" "}
          <h2 className="heading"> Product Details</h2>
        </div>
        <Button
          form="my-form"
          type="submit"
          variant="contained"
          color="secondary"
          sx={{ fontWeight: "600", letterSpacing: "1px", width: "140px" }}
        >
          {loading ? <CircularProgress /> : "Update"}
        </Button>
      </Box>

      {product ? (
        <Box component="form" onSubmit={updateProduct} id="my-form">
          <div className="product">
            <div
              className="left"
              style={{
                backgroundColor: colors.primary[400],
              }}
            >
              <h2>Product Information</h2>
              <p>
                Enter the required information below . You can change it anytime
                you want.
              </p>
              <TextField
                margin="normal"
                color="secondary"
                required
                fullWidth
                id="Title"
                label="Title"
                name="Title"
                autoComplete="text"
                size="small"
                value={title}
                onChange={(e) => {
                  settitle(e.target.value);
                }}
                placeholder="Title"
              />
              <TextField
                margin="normal"
                color="secondary"
                required
                fullWidth
                id="Quantity"
                label="Quantity"
                name="Quantity"
                autoComplete="text"
                size="small"
                value={quantity}
                onChange={(e) => {
                  setquantity(e.target.value);
                }}
              />
              <TextField
                margin="normal"
                color="secondary"
                required
                fullWidth
                id="Price"
                label="Price"
                name="Price"
                autoComplete="text"
                size="small"
                value={price}
                onChange={(e) => {
                  setprice(e.target.value);
                }}
              />

              <TextField
                margin="normal"
                color="secondary"
                required
                fullWidth
                id="MRP"
                label="MRP"
                name="MRP"
                autoComplete="text"
                size="small"
                value={MRP}
                onChange={(e) => {
                  setMRP(e.target.value);
                }}
              />
              <TextField
                margin="normal"
                color="secondary"
                required
                fullWidth
                id="tax"
                label="Tax( in % )"
                name="tax"
                autoComplete="text"
                size="small"
                value={tax}
                type="number"
                InputProps={{ inputProps: { min: 0, max: 99 } }}
                onChange={(e) => {
                  settax(e.target.value);
                }}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="Stock"
                color="secondary"
                label="Stock"
                name="Stock"
                type="number"
                InputProps={{ inputProps: { min: 0, max: 10000 } }}
                autoComplete="number"
                size="small"
                value={stock}
                onChange={(e) => {
                  if (e.target.value <= 0) {
                    setstock(0);
                  } else {
                    setstock(e.target.value);
                  }
                }}
              />
              <div className="sub">
                <label htmlFor="subscrip" className="subMAin">
                  Subscription
                </label>
                <div class="toggle-switch">
                  <input
                    class="toggle-input"
                    color="secondary"
                    id="toggle"
                    type="checkbox"
                    checked={subs === 1}
                    onChange={() => {
                      setsubs(subs === 1 ? 0 : 1);
                    }}
                  />
                  <label class="toggle-label" for="toggle"></label>
                </div>
              </div>

              <div className="sub">
                <label htmlFor="hasbottletoggle" className="subMAin">
                  Has Glass Bottle
                </label>
                <div class="toggle-switch">
                  <input
                    class="toggle-input"
                    id="hasbottletoggle"
                    type="checkbox"
                    checked={hasbottle === 1}
                    onChange={() => {
                      sethasbottle(hasbottle === 1 ? 0 : 1);
                    }}
                  />
                  <label class="toggle-label" for="hasbottletoggle"></label>
                </div>
              </div>

              <div className="auto">
                <Autocomplete
                  color="secondary"
                  disablePortal
                  sx={{ width: "45%", marginTop: "40px" }}
                  id="category-select"
                  value={category}
                  options={categories}
                  onChange={(e, data) => {
                    setcategory(data);
                    setsubCat(null); // Reset subcategory when category changes
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Category"
                      size="small"
                      fullWidth
                      required
                      color="secondary"
                    />
                  )}
                />
                <Autocomplete
                  disablePortal
                  color="secondary"
                  sx={{ width: "45%", marginTop: "20px" }}
                  id="subcategory-select"
                  value={subCat}
                  options={subCategories}
                  disabled={!category}
                  onChange={(e, data) => {
                    setsubCat(data);
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      color="secondary"
                      label="Sub Category"
                      size="small"
                      fullWidth
                      required
                      helperText={!category ? "Please select a category first" : ""}
                    />
                  )}
                />
              </div>
            </div>
            <div
              className="right"
              style={{
                backgroundColor: colors.primary[400],
              }}
            >
              <div className="image">
                <label htmlFor="productImage" className="lbl">
                  Product Image
                </label>
                <div className="imgDiv">
                  <div className="img" style={{ position: "relative" }}>
                    <img
                      src={
                        img.url
                          ? img.url
                          : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTANRJhlfd2yzWf0UxKDBMw_jDOC3SVwkDBreJjA_Gp&s"
                      }
                      alt="img"
                    />
                    {img.id && (
                      <button
                        onClick={() => {
                          deleteFile(img.id);
                        }}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          height: "30px",
                          padding: "0 10px",
                          border: "none",
                          borderRadius: "5px",
                          backgroundColor: "#d32f2f",
                          color: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        {deleting ? (
                          <CircularProgress size={10} color="white" />
                        ) : (
                          <DeleteOutline sx={{ fontSize: "28px" }} />
                        )}
                      </button>
                    )}
                  </div>
                  <div className="upload">
                    {" "}
                    <Button
                      color="secondary"
                      aria-label="upload picture"
                      component="label"
                      variant="contained"
                      onChange={(e) => {
                        if (e.target.files[0].size / 1024 >= 2048) {
                          alert("file size must be less then 2mb");
                          return false;
                        }
                        if (
                          e.target.files &&
                          e.target.files[0] &&
                          e.target.files[0].size / 1024 <= 2048
                        ) {
                          setimg({
                            url: URL.createObjectURL(e.target.files[0]),
                          });
                          setuploadImage(e.target.files[0]);
                        }
                      }}
                    >
                      <input hidden accept=".png, .jpg, .jpeg" type="file" />
                      Select Image <PhotoCamera />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="desc"
            style={{
              backgroundColor: colors.primary[400],
            }}
          >
            <h2>Additional Images</h2>

            <Box display={"flex"} alignItems="center" gap="20px" mt={4}>
              <div class="container">
                {sliderImages?.map((slider) => (
                  <div className="img">
                    {" "}
                    <img
                      src={`${image}/${slider.image}`}
                      alt=""
                      width={"150px"}
                    />
                    <button
                      onClick={() => {
                        deleteFile(slider.id);
                      }}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        height: "30px",
                        padding: "0 10px",
                        border: "none",
                        borderRadius: "5px",
                        backgroundColor: "#d32f2f",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                    >
                      {deleting ? (
                        <CircularProgress size={10} color="white" />
                      ) : (
                        <DeleteOutline sx={{ fontSize: "28px" }} />
                      )}
                    </button>
                  </div>
                ))}

                {sliderImages.length >= 5 ? (
                  <></>
                ) : (
                  <div
                    className="upload"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <IconButton aria-label="upload picture" component="label">
                      <input
                        hidden
                        accept=".png, .jpg, .jpeg"
                        type="file"
                        onChange={async (e) => {
                          if (e.target.files[0].size / 1024 >= 2048) {
                            alert("file size must be less then 2mb");
                          }
                          if (
                            e.target.files &&
                            e.target.files[0] &&
                            e.target.files[0].size / 1024 <= 2048
                          ) {
                            let UploadUrl = `${api}/product/upload_image`;
                            const uploadData = {
                              image: e.target.files[0],
                              image_type: 2,
                              id: param.id,
                            };

                            setuploading(true);
                            const upload = await UPLOAD(
                              token,
                              UploadUrl,
                              uploadData
                            );
                            setuploading(false);

                            if (upload.response === 200) {
                              handleSnakBarOpen();
                              setalertType("success");
                              setalertMsg("Uploaded");
                              setreFetch(!reFetch);
                            } else if (upload.response === 201) {
                              handleSnakBarOpen();
                              setalertType("error");
                              setalertMsg(upload.message);
                            } else {
                              handleSnakBarOpen();
                              setalertType("error");
                              setalertMsg(
                                "Something went Wrong! Please Try Again"
                              );
                            }
                          }
                        }}
                      />
                      {uploading ? (
                        <CircularProgress />
                      ) : (
                        <AddPhotoAlternateIcon sx={{ fontSize: "80px" }} />
                      )}
                    </IconButton>
                  </div>
                )}
              </div>
            </Box>
          </div>
          <div
            className="desc"
            style={{
              backgroundColor: colors.primary[400],
            }}
          >
            <h2>Other Information</h2>

            <TextField
              margin="normal"
              color="secondary"
              fullWidth
              id="Offer"
              label="Offer"
              name="Offer"
              autoComplete="text"
              size="small"
              value={offer}
              onChange={(e) => {
                setoffer(e.target.value);
              }}
            />
            <TextField
              margin="normal"
              color="secondary"
              fullWidth
              id="Description"
              label="Description"
              name="Description"
              autoComplete="text"
              size="small"
              multiline
              value={desc}
              onChange={(e) => {
                setdesc(e.target.value);
              }}
            />
            <TextField
              margin="normal"
              color="secondary"
              fullWidth
              id="Disclaimer"
              label="Disclaimer"
              name="Disclaimer"
              autoComplete="text"
              size="small"
              minRows="3"
              multiline
              value={claimer}
              onChange={(e) => {
                setclaimer(e.target.value);
              }}
            />
          </div>

          {/* Order Time Restriction */}
          <div className="desc" style={{ backgroundColor: colors.cardBG[400] }}>
            <h2>⏰ Order Time Restriction</h2>
            <p>Set a time window during which customers can place orders for this product.</p>
            <div className="sub" style={{ marginBottom: "12px" }}>
              <label className="subMAin">Enable Time Restriction</label>
              <div className="toggle-switch">
                <input
                  className="toggle-input"
                  id="toggleTimeEdit"
                  type="checkbox"
                  checked={enableTimeRestriction}
                  onChange={(e) => {
                    setEnableTimeRestriction(e.target.checked);
                    if (!e.target.checked) {
                      setOrderStartTime("");
                      setOrderEndTime("");
                    }
                  }}
                />
                <label className="toggle-label" htmlFor="toggleTimeEdit"></label>
              </div>
            </div>
            {enableTimeRestriction && (
              <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
                <TextField
                  label="Order Start Time"
                  type="time"
                  size="small"
                  color="secondary"
                  value={orderStartTime}
                  onChange={(e) => setOrderStartTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  helperText="Orders allowed FROM this time"
                  sx={{ flex: 1 }}
                />
                <TextField
                  label="Order End Time"
                  type="time"
                  size="small"
                  color="secondary"
                  value={orderEndTime}
                  onChange={(e) => setOrderEndTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  helperText="Orders allowed UNTIL this time"
                  sx={{ flex: 1 }}
                />
              </div>
            )}
          </div>

          {/* Pincode Restriction */}
          <div className="desc" style={{ backgroundColor: colors.cardBG[400] }}>
            <h2>📍 Pincode Restriction</h2>
            <p>Restrict this product to specific delivery pincodes. If none selected, product is available everywhere.</p>
            <div className="sub" style={{ marginBottom: "12px" }}>
              <label className="subMAin">Enable Pincode Restriction</label>
              <div className="toggle-switch">
                <input
                  className="toggle-input"
                  id="togglePinEdit"
                  type="checkbox"
                  checked={enablePincodeRestriction}
                  onChange={(e) => {
                    setEnablePincodeRestriction(e.target.checked);
                    if (!e.target.checked) setSelectedPincodes([]);
                  }}
                />
                <label className="toggle-label" htmlFor="togglePinEdit"></label>
              </div>
            </div>
            {enablePincodeRestriction && (
              <Autocomplete
                multiple
                options={allPincodes}
                getOptionLabel={(option) => option.pin_code?.toString() || ""}
                isOptionEqualToValue={(option, value) =>
                  option.pin_code?.toString() === value.pin_code?.toString()
                }
                value={selectedPincodes}
                onChange={(e, val) => setSelectedPincodes(val)}
                size="small"
                color="secondary"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Allowed Pincodes"
                    color="secondary"
                    helperText={`${selectedPincodes.length} pincode(s) selected — product only available in these areas`}
                  />
                )}
              />
            )}
          </div>

          <div className="delete">
            <Button
              fullWidth
              variant="contained"
              color="error"
              sx={{ fontWeight: "600", letterSpacing: "1px" }}
              onClick={handleClickOpen}
            >
              Delete
            </Button>
          </div>
        </Box>
      ) : (
        <Stack spacing={1}>
          {/* For variant="text", adjust the height via font-size */}
          <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
          {/* For other variants, adjust the size with `width` and `height` */}

          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <Skeleton variant="rounded" width={"100%"} height={60} />
        </Stack>
      )}
      <Dialog
        open={DailogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>Do You Want to Delete {product?.title}</DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="contained"
            color="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={DeleteProduct}
            autoFocus
            variant="contained"
            color="error"
            size="small"
          >
            {loading ? <CircularProgress /> : "Yes! Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Product;
